import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MemberQuery } from '../../../account/member/member.query';
import { LoginType } from '../../../account/models/login-response.model';
import { AuthService } from '../../../user/services/auth.service';
import { LoggingService } from './logging.service';

/**
 * Guards against pages being accessible when maintence mode is on
 * Admin users are not affected by this guard and are always allowed to activate
 */
@Injectable()
export class MaintenanceGuard  {
  maintenanceUrl = '/maintenance';
  constructor(
    private authService: AuthService,
    private memberQuery: MemberQuery,
    private router: Router,
    private logService: LoggingService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.checkMaintenceMode();
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.checkMaintenceMode();
  }

  private checkMaintenceMode(): Observable<boolean | UrlTree> {
    // Admin users should be able to browse with maintence mode on
    if (this.authService.isAuthenticated() && this.memberQuery.getLoginType() == LoginType.Admin) {
      return of(true);
    }

    return this.authService.checkMaintenceMode().pipe(
      map(() => true),
      catchError((err) => {
        if (err.status == 503) {
          this.logService.warning('503 [Service Unavailable] received; Maintenance mode is probably on', err);
        } else {
          this.logService.error('500 [Internal API Error] received', err);
        }

        return of(this.router.parseUrl(this.maintenanceUrl));
      })
    );
  }
}
